export enum TypePayment {
  wire = 'WIRE',
  stellar = 'STELLAR',
}
